import StudyDetailsForm from "./StudyDetailsForm";
import { CENTER, DATATABLE_EXPORT } from "../../../../../../../Config/ApiUrl";

export const StudyDetailsSchema = {
	components: { StudyDetailsForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "center-table",
			rowData: {},
			formId: "center-form",
			tableColumns: [
				{
					title: "Study Day",
					type: "text",
					key: "name",
				},
				{
					title: "Start Time",
					type: "text",
					key: "name",
				},
				{
					title: "Finish Time",
					type: "text",
					key: "name",
				},
				{
					title: "Class Type",
					type: "text",
					key: "name",
				},
				{
					title: "CLC Centre",
					type: "text",
					key: "name",
				},
				{
					title: "Classroom",
					type: "text",
					key: "name",
				},
				{
					title: "Note",
					type: "text",
					key: "name",
				},
			],
			ENDPOINT: CENTER,
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "Center",
				url: CENTER,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						modalId: "center-form",
					},
				],
				showFilter: false,
				showSearch: false,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = `${this.ENDPOINT}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
	},
};
